import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import Icon from "../Icon";

export interface DraggableRowHandleProps {
	provided: DraggableProvided;
}

export const DraggableRowHandle: React.FC<DraggableRowHandleProps> = ({ provided }) => {
	return (
		<div {...provided.dragHandleProps} className="draggable-row-handle btn btn-sm btn-square cursor-move">
			<Icon icon="arrows" classes="fa-fw" />
		</div>
	);
};
